// Web shim for @react-native-firebase/app – no-op implementations

export const getApps = () => [];

export const getApp = () => null;

export const initializeApp = (_config?: any) => {
  // Return a dummy app object
  return {};
};

export default {
  getApps,
  getApp,
  initializeApp,
};
